<template>
  <AppLayout />
</template>

<script>
import AppLayout from "./components/AppLayout.vue";

export default {
  name: "App",
  components: {
    AppLayout,
  },
};
</script>
